/**
 * 路由常量定义
 * 避免循环依赖，将路由常量提取到独立文件
 */
export const pageEditorRouteName = 'pageConfig';
export const pageEditorRoutePath = '/project/pageconfig';
export const aiProjectEditorRouteName = 'aiProjectEditor';
export const aiProjectEditorRoutePath = '/project/ai-editor';
export const componentEditorRouteName = 'componentEditor';
export const componentEditorRoutePath = '/project/editor/component';
export const templateEditorRouteName = 'templateEditor';
export const templateEditorRoutePath = '/project/editor/template';
export const aiMergeEditorRouteName = 'aiMergeEditor';
export const aiMergeEditorRoutePath = '/project/ai-editor-merge';
export const aiEditorRemoteRouteName = 'aiEditorRemote';
export const aiEditorRemoteRoutePath = '/project/ai-editor-remote';
export const aiEditorAutoRouteName = 'aiEditorAuto';
export const aiEditorAutoRoutePath = '/project/ai-editor-auto';
